import React from "react";
import {Pagination} from "react-bootstrap";

function STCPaginationItem(props){

    return(
        <Pagination.Item
            style={props.style}
            className={props.className}

            active={props.active}
            activeLabel={props.activeLabel}
            disabled={props.disabled}
            href={props.href}
            onClick={props.onClick}

        >
            {props.children}
        </Pagination.Item>
    )
}
export default STCPaginationItem;